import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'sportsline-free-expert-pick-footer',
  styleUrl: 'sportsline-free-expert-pick-footer.css',
  shadow: true,
})
export class SportslineFreeExpertPickFooter {
  /**
   * The link to the subscription page.
   */
  @Prop() href?: string;
  /**
   * The text to be displayed in the upsell section.
   * This is a required prop.
   */
  @Prop() upsellText?: string;
  render() {
    return (
      <Host>
        {this.upsellText && (
          <div class="free-expert-pick-footer">
            <sportsline-company-logo />
            <span class="free-expert-pick-footer__text">{this.upsellText}</span>
            {this.href && (
              <sportsline-button variant="primary" href={this.href}>
                {'Subscribe Now'}
              </sportsline-button>
            )}
          </div>
        )}
      </Host>
    );
  }
}
